import { ThunkAction } from 'redux-thunk'
import { Action, Dispatch } from 'redux'
import { ApplicationState } from 'store'
import { GENERATE_CODE, Channel } from './types'
import { ChannelActionTypes } from './types'
import { APIRequest } from 'lynxapirequests'

const channelInternal = (channel: Channel): ChannelActionTypes => {
	return {
		type: GENERATE_CODE,
		payload: channel
	}
}

export const generateCode = (fileId: string): ThunkAction<Promise<boolean>, ApplicationState, null, Action<string>> => async (dispatch: Dispatch):	Promise<boolean> => {
	try {
		console.log('Generating Code')
		const code = await APIRequest.Channels.generateCode(fileId, 'fileId')
		dispatch(
			channelInternal({
				CODE: code,
				FILE_ID: fileId
			})
		)
		return true
	} catch(e) {
		console.error(e)
		return false
	}
}
